(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["elevar-customizations"] && !Shopify.designMode) return;
  try {
    window.ElevarTransformFn = item => {
            const userLocale = window.Shopify.routes.root.split("/").filter(Boolean).join("").replace('-', '_');
            
            if (item.event === "dl_user_data") {
                return {
                    ...item,
                    ecommerce: {
                        ...item.ecommerce,
                        locale: userLocale
                    }
                }
            } else {
                return item;
            }
        };
  } catch(e) { console.error(e); }
})();

})();
